
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claim/agency",
      function () {
        return require("private-next-pages/claim/agency/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claim/agency"])
      });
    }
  